
import { TranslateService } from '@ngx-translate/core';
import { Language } from 'src/core/utility/enums/enums';
import { NgZone } from '@angular/core';

export abstract class BaseTranslation {

    //#region Properties
    public translate: TranslateService;
    public ngZone:NgZone;
    //#endregion

    //#region Constructor
    constructor(translate: TranslateService,ngZone:NgZone) {
    
       this.translate = translate;
       this.ngZone=ngZone;
       this.ngZone.run(() => {
       
       this.translate.setDefaultLang(Language[_spPageContextInfo.currentLanguage]);
       this.translate.use(Language[_spPageContextInfo.currentLanguage]);
       });

    }
    //#endregion

}